/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserHasMonitoredObjectGroup,
    ReadOnlyUserHasMonitoredObjectGroupFromJSON,
    ReadOnlyUserHasMonitoredObjectGroupFromJSONTyped,
    ReadOnlyUserHasMonitoredObjectGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20042
 */
export interface InlineResponse20042 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20042
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20042
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20042
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserHasMonitoredObjectGroup>}
     * @memberof InlineResponse20042
     */
    results: Array<ReadOnlyUserHasMonitoredObjectGroup>;
}

export function InlineResponse20042FromJSON(json: any): InlineResponse20042 {
    return InlineResponse20042FromJSONTyped(json, false);
}

export function InlineResponse20042FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20042 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserHasMonitoredObjectGroupFromJSON)),
    };
}

export function InlineResponse20042ToJSON(value?: InlineResponse20042 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserHasMonitoredObjectGroupToJSON)),
    };
}


